import { UseQueryResult, useQuery } from 'react-query'
import request from '../../request'
import { useDealership } from '../../../store/zustand/dealershipStore'

type ResultType = {
  inventory_data_provider_id: number
  inventory_data_provider_name: string
  from_website: boolean
}

export const useGetInventoryDataProviderDetails = (): UseQueryResult<
  {
    data: Array<ResultType>
  },
  Error
> => {
  const dealership = useDealership()
  return useQuery<{ data: Array<ResultType> }, Error>(
    ['inventory', 'dealership', dealership?.id, 'data_providers'],
    ({ signal }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/inventory/data-providers/details`,
        signal,
      }),
    { keepPreviousData: true },
  )
}
